import React, { useState, useEffect } from 'react';
import { FotosImovel } from '../../data/Imovel';

interface ImovelFotoEditModalProps {
  show: boolean;
  onClose: () => void;
  onSave: (foto: FotosImovel) => Promise<void>;
  foto: FotosImovel | null;
  loading: boolean;
}

const ImovelFotoEditModal: React.FC<ImovelFotoEditModalProps> = ({ show, onClose, onSave, foto, loading, }) => {
  const [descricao, setDescricao] = useState('');
  const [destaque, setDestaque] = useState(false);

  useEffect(() => {
    if (foto) {
      setDescricao(foto.descricao || '');
      setDestaque(!!foto.destaque);
    }
  }, [foto]);

  const handleSave = () => {
    if (foto) {
      onSave({
        ...foto,
        descricao,
        destaque,
      });
    }
  };

  if (!show || !foto) {
    return null;
  }

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show" style={{ display: 'block' }} tabIndex={-1} role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Editar Foto</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close" disabled={loading}></button>
            </div>
            <div className="modal-body">
              <img src={foto.url} alt={foto.descricao || 'Foto do imóvel'} className="img-fluid mb-3 rounded" />
              <form>
                <div className="mb-3">
                  <label htmlFor="formDescricaoFoto" className="form-label">Descrição</label>
                  <input
                    type="text"
                    id="formDescricaoFoto"
                    className="form-control"
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                  />
                </div>
                <div className="mb-3 form-check">
                  <input type="checkbox" id="formDestaqueFoto" className="form-check-input" checked={destaque} onChange={(e) => setDestaque(e.target.checked)} />
                  <label htmlFor="formDestaqueFoto" className="form-check-label">Foto Destaque</label>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>Cancelar</button>
              <button type="button" className="btn btn-primary" onClick={handleSave} disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImovelFotoEditModal;